import { RequestJobs, SubscriptionEvents } from "../MSRP/cmsgTypes";
import Endpoint from "../MSRP/endPointManager";
import { triggerHandleAgentListResponse } from "../controllers/agentListController";
import { MyRequest } from "../models/MyRequest.ts";
import { MyNotifications } from "../models/MyNotifications.ts";
import { createResponseControlMessage, createResponseControlMessageReadyParams } from "./cmsgBuilder";
import Global from "../globals/globals.ts";
import { FileMessage } from "../models/FileMessage.ts";
import { toast } from 'react-toastify';
import i18n from "../i18n";
import 'react-toastify/dist/ReactToastify.css';
import obtainSessionKey  from "../MSRP/utilities/obtainSessionKey.js";
import { MessageQueue } from "./messageQueue";
import generateRandomString from "../MSRP/utilities/generators";
import { ConnectionEventHandlers } from "./connectionEventHandlers";

export class Wrapper {
  constructor(
    host,
    port,
    name,
    pass,
    companyDomain,
    sessId,
    authHost,
    authPort,
    authSessId,
    msrpRole,
    msrpSubrole,
    addRoomCallback,
    handlereceiveFileMessage,
    handleReceiveMessage,
    requestcontroller,
    notificationController,
    controller,
    handleSessionActivation,
    handleChatListResponse,
    setIsCreator,
    setAvailableRooms,
    addNotification,
    handleRemoveMessage,
    handleupdateMessage,
    handleaddRequest,
    handleremoveRequest,
    handleaddServerRequest,
    handleremoveServerRequest,
    handlefindServerRequest,
    handlefindRequest,
    handleupdateReqStatusById,
    handleAddMessageHistory,
    // handleAddMessageHistoryArray,
    clearAllChatRooms,
    handleLeaveFromChat,
    handleAddParticipant,
    handleRemoveParticipant,
    updateMessageStatus
  ) {
    this.username = name;
    this.password = pass;
    this.endpoint = new Endpoint(host, port, name, pass, companyDomain,sessId, authHost, authPort, authSessId, msrpRole, msrpSubrole);

    // Message queue for offline/reconnection scenarios
    this.messageQueue = new MessageQueue();
    this.connectionState = 'disconnected';

    // Browser event handlers (sleep/wake, network online/offline)
    this.connectionEventHandlers = new ConnectionEventHandlers(this.endpoint, this);
    this.connectionEventHandlers.initialize();

    this.addRoomCallback = addRoomCallback;
    this.handleReceiveMessage = handleReceiveMessage;
    this.handlereceiveFileMessage = handlereceiveFileMessage;
    this.notificationController = notificationController;
    this.controller = controller;
    this.requestcontroller = requestcontroller;
    this.handleSessionActivation = handleSessionActivation;
    this.handleChatListResponse = handleChatListResponse;
    this.setAvailableRooms = setAvailableRooms;
    this.setIsCreator = setIsCreator;
    this.addNotification = addNotification;
    this.handleRemoveMessage = handleRemoveMessage;
    this.handleupdateMessage = handleupdateMessage;
    this.handleaddRequest = handleaddRequest;
    this.handleremoveRequest = handleremoveRequest;
    this.handleaddServerRequest = handleaddServerRequest;
    this.handleremoveServerRequest = handleremoveServerRequest;
    this.handlefindServerRequest = handlefindServerRequest;
    this.handlefindRequest = handlefindRequest;
    this.handleupdateReqStatusById = handleupdateReqStatusById;
    this.handleAddMessageHistory = handleAddMessageHistory;
    this.companyDomain = companyDomain;
    this.clearAllChatRooms = clearAllChatRooms;
    this.handleLeaveFromChat = handleLeaveFromChat;
    this.handleAddParticipant = handleAddParticipant;
    this.handleRemoveParticipant = handleRemoveParticipant;
    this.updateMessageStatus = updateMessageStatus;

    this.endpoint.on("onUrgentMsg", (msg, messageId, sender, receiver, type) => {
      this.onUrgentMsg(msg, messageId, sender, receiver, type);
    });

    this.endpoint.on("onMsg", (msg, messageId, sender, receiver, type) => {
      this.onMsg(msg, messageId, sender, receiver, type);
    });


    this.endpoint.on("onMsgHistory", (text, messageId, isowner,sender,receiver,role, sentTime, deliveredTime, seenTimes, editTime, deletedTime,repliedMessageId, messageType,  
    fileData, pageNumber, totalPageNumber) => {
      console.log("wrapper text:", text);
      this.onMsgHistory(text, messageId, isowner,sender,receiver,role, sentTime, deliveredTime, seenTimes, editTime, deletedTime,repliedMessageId, messageType, fileData, pageNumber, totalPageNumber);
    });

    this.endpoint.on("onEdit", (msg, currentMessageId, sender, receiver, type) => {
      this.onEdit(msg, currentMessageId, sender, receiver, type);
    });


    this.endpoint.on("onReply", (msg, messageID,repliedMessageId, sender, receiver,type) => {
      this.onReply(msg,messageID, repliedMessageId, sender,receiver,type);
    });

    this.endpoint.on("ReqCmsg", (msg) => {
      this.passRequestDataToUp(msg);
    });

    this.endpoint.on("RespCmsg", (msg) => {
      this.passResponseDataToUp(msg);
    });

    this.endpoint.on("NotfCmsg", (msg) => {
      this.passNotifyDataToUp(msg);
    });
    this.endpoint.on("Delivered", (messageID,deliveredTime) => {
      console.log("message with id: " + messageID + " is delivered at: " + deliveredTime);
        this.updateMessageStatus(messageID, "deliveredTime",new Date(deliveredTime * 1000),"");
   });
   this.endpoint.on("Sent", (messageID,sentTime) => {
      console.log("message with id: " + messageID + " is sent at: " + sentTime);
        this.updateMessageStatus(messageID, "sentTime",new Date(sentTime * 1000),"");
   });

   // Reconnection event handlers
   this.endpoint.on("connectionStateChanged", (state) => {
      console.log("Wrapper received connection state change:", state);
      this.connectionState = state;

      // Enable queue persistence during reconnection
      if (state === 'reconnecting') {
        this.messageQueue.enablePersistence();
      } else if (state === 'authenticated') {
        this.messageQueue.disablePersistence();
      }
   });

   this.endpoint.on("reconnecting", (data) => {
      console.log(`Wrapper: Reconnecting... attempt ${data.attempt}/${data.maxRetries}`);
      // Toast removed - connection status is now shown in banner
   });

   this.endpoint.on("reconnected", () => {
      console.log("Wrapper: Reconnected successfully");
      // Toast removed - connection status banner will disappear automatically

      // Reset counter to allow chat-list request on reconnection
      Global.counter = 0;

      // Send chat-list request after reconnection (same as initial login)
      // this.sendInitialChatListRequest();

      // Flush message queue after successful reconnection
      this.flushMessageQueue();
   });

   this.endpoint.on("maxRetriesReached", () => {
      console.log("Wrapper: Max reconnection retries reached");
      this.connectionState = 'offline';
      toast.error("Connection failed. Please check your network.", {
        autoClose: false
      });
   });

   this.endpoint.on("sessionExpired", () => {
      console.log("Wrapper: Session expired");
      // EndpointManager already handles redirect to login
   });

   this.endpoint.on("auth_complete", () => {
      console.log("Wrapper: Authentication complete");
      this.connectionState = 'authenticated';

      // Note: chat-list request is sent in "reconnected" event for reconnections
      // For initial login, it's sent from LoginPage.tsx after authorize() succeeds

      // Flush message queue after successful auth
      this.flushMessageQueue();
   });

   this.initializeMobileNotifications();

  }


  

//notification functions

closeConnection() {
  // Clean up connection event handlers
  if (this.connectionEventHandlers) {
    this.connectionEventHandlers.cleanup();
  }

  // Clear message queue
  if (this.messageQueue) {
    this.messageQueue.clear();
  }

  this.endpoint.closeConnection("ws");
}

  async initializeMobileNotifications() {
    const support = this.checkMobileNotificationSupport();
    
    if (!support.supported) {
      console.warn('Mobile notifications not fully supported:', support.reason);
      return false;
    }
    
    if ('serviceWorker' in navigator) {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js');
        console.log('Service Worker registered successfully');
        this.swRegistration = registration;
      } catch (error) {
        console.error('Service Worker registration failed:', error);
        return false;
      }
    }
    
    return true;
  }

  checkMobileNotificationSupport() {
    const userAgent = navigator.userAgent;
    const isIOS = /iPhone|iPad|iPod/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    const isIOSPWA = window.navigator.standalone === true;
    
    console.log('Mobile notification support check:');
    console.log('- Is iOS:', isIOS);
    console.log('- Is Android:', isAndroid);
    console.log('- Is iOS PWA:', isIOSPWA);
    console.log('- Service Worker supported:', 'serviceWorker' in navigator);
    console.log('- Notification supported:', 'Notification' in window);
    console.log('- Current permission:', Notification.permission);
    
    if (isIOS && !isIOSPWA) {
      return {
        supported: false,
        reason: 'iOS Safari requires the app to be added to home screen for notifications'
      };
    }
    
    if (!('serviceWorker' in navigator)) {
      return {
        supported: false,
        reason: 'Service Worker not supported - required for reliable mobile notifications'
      };
    }
    
    return { supported: true, reason: 'Notifications should work' };
  }

  async showUrgentNotification(message, sender) {
    const senderName = sender.split("@")[0];
    
    if (!("Notification" in window)) {
      console.log("This browser does not support notifications");
      this.showInAppNotification(message, senderName);
      return;
    }

    if (Notification.permission !== "granted") {
      console.log("Notification permission not granted");
      this.showInAppNotification(message, senderName);
      return;
    }

    try {
      await this.createMobileCompatibleNotification(
        `Urgent Message from ${senderName}`,
        message,
        sender
      );
    } catch (error) {
      console.error("Failed to show notification:", error);
      this.showInAppNotification(message, senderName);
    }
  }

  async createMobileCompatibleNotification(title, message, sender) {
    try {
      if (document.hidden) {
        console.log('Page is hidden, notification may be blocked');
      }

      if (this.swRegistration && this.swRegistration.showNotification) {
        await this.swRegistration.showNotification(title, {
          body: message,
          icon: '/important.png', 
          badge: '/alarm.png',
          tag: 'urgent-message',
          requireInteraction: true,
          silent: false,
          vibrate: [200, 100, 200],
          data: {
            sender: sender,
            timestamp: Date.now(),
            url: '/'
          },
          actions: [
            {
              action: 'open',
              title: 'Open Chat'
            }
          ]
        });
        console.log('Service Worker notification sent');
        return true;
      }

      const notification = new Notification(title, {
        body: message,
        icon: '/important.png',
        badge: '/alarm.png',
        tag: 'urgent-message',
        requireInteraction: true,
        silent: false,
        vibrate: [200, 100, 200]
      });

      notification.onclick = function(event) {
        event.preventDefault();
        window.focus();
        notification.close();
      };

      setTimeout(() => {
        notification.close();
      }, 10000);

      console.log('Regular notification sent');
      return true;

    } catch (error) {
      console.error('Error creating notification:', error);
      return false;
    }
  }

  showInAppNotification(message, senderName) {
    if (typeof toast !== 'undefined') {
      toast(`🚨 Urgent Message from ${senderName}: ${message}`, {
        type: "warning",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      alert(`Urgent Message from ${senderName}: ${message}`);
    }
  }

  onUrgentMsg(msg, messageId, sender, receiver, type) {
    console.log("Urgent message received:", msg, "from:", sender);
    this.showUrgentNotification(msg, sender);
  }

  async requestNotificationPermissionWithInteraction() {
    if (!('Notification' in window)) {
      console.log('This browser does not support notifications');
      return false;
    }

    const isIOSSafari = /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isIOSPWA = window.navigator.standalone === true;
    
    if (isIOSSafari && !isIOSPWA) {
      console.log('iOS Safari detected - notifications only work in PWA mode');
      return false;
    }

    try {
      const permission = await Notification.requestPermission();
      console.log('Notification permission:', permission);
      
      if (permission === 'granted') {
        await this.createMobileCompatibleNotification(
          'Notifications Enabled',
          'You will now receive notifications for urgent messages',
          'System'
        );
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return false;
    }
  }


//notification functions end

  openSocket() {
    return new Promise((resolve, reject) => {
      try {
        //TODO: fix listerners
        // Ensure remove previous listeners to prevent memory leaks
        // this.endpoint.removeAllListeners("socketOpened");
        // this.endpoint.removeAllListeners("canStartAuth");
        // this.endpoint.removeAllListeners("connectionError");

        this.endpoint.openSocket("ws");

        this.endpoint.once("canStartAuth", () => {
          console.log("canStartAuth event received");
          resolve(true);
        });

        this.endpoint.once("connectionError", (err) => {
          console.error("Socket connection error in wrapper:", err);
          resolve(err);
        });
      } catch (err) {
        clearTimeout(timeoutId);
        console.error("Unexpected error in openSocket:", err);
        reject(err);
      }
    });
  }

  authorize() {
    return new Promise((resolve, reject) => {
      console.log("Wrapper :: Authorizing...");
      this.endpoint.emit("startAuth");

      // Listen for auth completion
      this.endpoint.once("auth_complete", () => {
        console.log("Authorization successful");
        resolve(1);
      });

      // Listen for auth failure
      this.endpoint.once("auth_failed", () => {
        console.log("Authorization failed");
        resolve(0);
      });
    });
  }

  // TODO: delete this after tests
  // authorize() {
  //   return new Promise((resolve, reject) => {
  //     this.endpoint.connect("ws");

  //     // Listen for auth completion
  //     this.endpoint.on("auth_complete", () => {
  //       console.log("Authorization successful");
  //       resolve(1);
  //     });

  //     // Listen for auth failure
  //     this.endpoint.on("auth_failed", () => {
  //       console.log("Authorization failed");
  //       resolve(0);
  //     });
  //   });
  // }

  sendMsg(body, type, headerMsgId = "") {
    // Check connection state - queue if not authenticated
    const shouldQueue = ['reconnecting', 'connecting', 'disconnected', 'offline'].includes(this.connectionState);

    console.log(`sendMsg called - connectionState: ${this.connectionState}, shouldQueue: ${shouldQueue}, headerMsgId: ${headerMsgId}`);

    if (shouldQueue) {
      // Queue message for later delivery
      const messageId = headerMsgId || generateRandomString(16);
      this.messageQueue.enqueue({
        id: messageId,
        timestamp: Date.now(),
        type: type,
        body: body,
        headerMsgId: headerMsgId,
        retryCount: 0,
        maxRetries: 3
      });

      console.log(`Message queued (connection state: ${this.connectionState}), queue size: ${this.messageQueue.size()}`);
      // Toast removed - message status "Sending..." is shown in UI

      return;
    }

    // Normal send
    console.log(`Sending message directly (authenticated), headerMsgId: ${headerMsgId}`);
    this.endpoint.createAndSendMessage(body, type, headerMsgId);
  }

  /**
   * Flush queued messages after reconnection
   */
  flushMessageQueue() {
    const queueSize = this.messageQueue.size();

    console.log(`flushMessageQueue called - queue size: ${queueSize}, connectionState: ${this.connectionState}`);

    if (queueSize === 0) {
      console.log("No messages to flush");
      return;
    }

    console.log(`Flushing ${queueSize} queued messages...`);

    // Remove stale messages (older than 5 minutes)
    const removedStale = this.messageQueue.removeStaleMessages(5 * 60 * 1000);
    if (removedStale > 0) {
      console.warn(`Removed ${removedStale} stale messages from queue`);
    }

    let successCount = 0;
    let failCount = 0;

    // Process all queued messages
    while (!this.messageQueue.isEmpty()) {
      const message = this.messageQueue.dequeue();

      if (!message) break;

      // Check retry count
      if (message.retryCount >= message.maxRetries) {
        console.error(`Message ${message.id} exceeded max retries`);
        failCount++;
        continue;
      }

      try {
        // Send the message
        console.log(`Sending queued message - headerMsgId: ${message.headerMsgId}, type: ${message.type}`);
        this.endpoint.createAndSendMessage(
          message.body,
          message.type,
          message.headerMsgId
        );
        console.log(`Queued message sent successfully - headerMsgId: ${message.headerMsgId}`);
        successCount++;
      } catch (err) {
        console.error(`Failed to send queued message: ${err}`);

        // Re-queue on failure
        message.retryCount++;
        this.messageQueue.enqueue(message);
        failCount++;

        // Stop processing on error
        break;
      }
    }

    // Only show toast for failures (success is shown in message UI)
    if (failCount > 0) {
      toast.warning(`${failCount} message(s) could not be sent`, {
        autoClose: 3000
      });
    }
  }

  /**
   * Get current connection state
   */
  getConnectionState() {
    return this.connectionState;
  }

  /**
   * Get message queue size
   */
  getQueueSize() {
    return this.messageQueue.size();
  }

  /**
   * Send initial chat-list request after authentication
   * This is the same request sent during initial login
   */
  // sendInitialChatListRequest() {
  //   console.log("Sending initial chat-list request after authentication");

  //   // Check if we have the necessary data
  //   if (!Global.username || !Global.companyDomain) {
  //     console.warn("Cannot send chat-list request: username or companyDomain missing");
  //     return;
  //   }

  //   // Prevent duplicate requests
  //   if (Global.counter === 1) {
  //     console.log("Chat-list request already sent, skipping");
  //     return;
  //   }

  //   const messageJson = {
  //     id: generateRandomString(16),
  //     type: "request",
  //     job: "chat-list",
  //     parameters: {
  //       "from-name": Global.username + Global.companyDomain,
  //       "chat-type": "any",
  //       personal: true,
  //       "session-status": "both",
  //     },
  //   };

  //   const messageJsonString = JSON.stringify(messageJson, null, 4);

  //   // Send the message
  //   this.endpoint.createAndSendMessage(
  //     messageJsonString,
  //     "application/rechat.cntl+json"
  //   );

  //   Global.counter = 1;
  //   console.log("Initial chat-list request sent successfully");
  // }



  sendFile(file, id, dispo) {
    this.endpoint.sendFileMessage(file, id, dispo);
  }

  onMsg(msg, messageId, sender, receiver, type) {
    this.handleReceiveMessage(msg, messageId, sender, receiver, false, type);
    console.log("ui received the message : " + msg + "from : " + sender + " to : " + receiver + "for chat type :" + type);
  }

   

  onMsgHistory(text, messageId, isowner, sender, receiver, role, sentTime, deliveredTime, seenTimes, editTime, deletedTime, repliedMessageId, messageType, fileData, pageNumber, totalPageNumber) {
    this.handleAddMessageHistory(
        text, 
        messageId, 
        isowner, 
        sender, 
        receiver, 
        role,
        sentTime ? new Date(sentTime * 1000) : null, 
        deliveredTime ? new Date(deliveredTime * 1000) : null, 
        seenTimes,
        editTime ? new Date(editTime * 1000) : null, 
        deletedTime ? new Date(deletedTime * 1000) : null,
        repliedMessageId,
        messageType,
        fileData,
        pageNumber,
        totalPageNumber
    );
  }
        
  onEdit(msg, currentMessageId, sender, receiver, type) {
    console.log("ui received the edit message : " + msg + "from : " + sender + " to : " + receiver + "for chat type :" + type + "currentMessageId: " + currentMessageId);
    this.handleupdateMessage(currentMessageId, msg);

  }
  onReply(msg,messageID, repliedMessageId, sender, receiver,type) {
    console.log("ui received the reply message : " + msg + "from : " + sender + " to : " + receiver + "repliedMessageId: " + repliedMessageId+"type"+type);
    this.handleReceiveMessage(msg,messageID,sender,receiver,false,type,repliedMessageId);
  }

  passRequestDataToUp(parsedMessage) {
    console.log("Wrapper :: Parsed Message ID:", parsedMessage.id);
    console.log("Wrapper :: Parsed Message Type:", parsedMessage.type);
    console.log("Wrapper :: Parsed Message Job:", parsedMessage.job);
    console.log("Wrapper :: Parsed Message Data:", JSON.stringify(parsedMessage.cm, null, 2));

    // parsedMessage.type may be an enum object like { enum: 'CMTYPE_REQUEST', str: 'request' }
    const parsedTypeStr = parsedMessage && parsedMessage.type && parsedMessage.type.str ? parsedMessage.type.str : String(parsedMessage.type || "");
    if (String(parsedTypeStr).toLowerCase() !== "request") {
      return;
    }

    const messageParams = parsedMessage.cm;

    switch (parsedMessage.job) {
      case RequestJobs.REQJOB_AGENT_TO_AGENT:
        console.log("real-time:",messageParams.realtime);
        if(messageParams.realtime===true){
          const request=new MyRequest(parsedMessage.id,messageParams.fromName,messageParams.toName,"agent-to-agent","pending","",true,"","");
        this.handleaddRequest(request);
        }else{
          const sessionId = "a2a:" + obtainSessionKey(messageParams.fromName, Global.username + Global.companyDomain);
          toast(`New ChatSession from ${messageParams.fromName.split("@")[0]}`, { type: "success" });
          this.addRoomCallback(sessionId, [], sessionId, "active", "agent-to-agent");
        }
       
        break;
      case RequestJobs.REQJOB_JOIN_CHAT:
        const req = new MyRequest(parsedMessage.id, messageParams.fromName, messageParams.chatroomId, "join-chat", "pending", messageParams.chatType, true, new Date().toISOString(), "");
        this.handleaddRequest(req);
        break;
      case RequestJobs.REQJOB_MEDIA_COMM_SCHED:
        console.log("media-comm-sched request received with id : " + parsedMessage.id);
        const scheduledAtSeconds = Number(messageParams.schedTime || messageParams["sched-time"] || 0);
        const scheduledAt = scheduledAtSeconds ? new Date(scheduledAtSeconds * 1000) : new Date();
        const durationHours = Number(messageParams.duration || 0.5);
        const fromScheduled = messageParams.fromName || messageParams["from-name"] || "";
        const targetScheduled = messageParams.targetName || messageParams["target-name"] || "";
        const commTypeScheduled = messageParams.commType || messageParams["comm-type"] || "audio";
        const mediaDescScheduled = messageParams.mediaDesc || messageParams["media-desc"] || {};

        const scheduledRequest = new MyRequest(
          parsedMessage.id,
          fromScheduled,
          targetScheduled,
          "media-comm-sched",
          "pending",
          {
            fromName: fromScheduled,
            targetName: targetScheduled,
            commType: commTypeScheduled,
            commMethod: messageParams.commMethod || messageParams["comm-method"] || "middlebox",
            schedTime: scheduledAtSeconds,
            duration: durationHours,
            mediaDesc: mediaDescScheduled,
          },
          true,
          new Date().toISOString(),
          ""
        );

        // Do not add scheduled calls to Requests list; show in Notifications only

        const notificationBody = `${fromScheduled.split("@")[0]} scheduled a ${commTypeScheduled} call for ${new Intl.DateTimeFormat(undefined, { dateStyle: "medium", timeStyle: "short" }).format(scheduledAt)}`;
        this.addNotification(new MyNotifications(
          parsedMessage.id,
          fromScheduled,
          targetScheduled,
          "media-comm-sched",
          false,
          {
            title: "Scheduled call",
            body: notificationBody,
            fromName: fromScheduled,
            targetName: targetScheduled,
            commType: commTypeScheduled,
            commMethod: messageParams.commMethod || messageParams["comm-method"] || "middlebox",
            schedTime: scheduledAtSeconds,
            duration: durationHours,
            mediaDesc: mediaDescScheduled,
          },
          new Date()
        ));
        // Also inject the control envelope as a room message so the schedule card
        // renders inside the conversation/sidebar. Normalize grpcht: names
        // (strip company suffix) to match how rooms are created locally.
        try {
          let injectedTarget = targetScheduled || "";
          // If target looks like "grpcht:room@domain", normalize to "grpcht:room"
          if (injectedTarget.startsWith("grpcht:") && injectedTarget.includes("@")) {
            injectedTarget = injectedTarget.replace(/@.*$/, "");
          }

          let injectedFrom = fromScheduled || "";
          if (injectedFrom.startsWith("grpcht:") && injectedFrom.includes("@")) {
            injectedFrom = injectedFrom.replace(/@.*$/, "");
          }

          // Decide a roomType heuristic so handleReceiveMessage will place the message
          // into the correct chat room. grpcht: -> group-chat, conf: -> conference,
          // otherwise default to agent-to-agent (a2a)
          let injectRoomType = "agent-to-agent";
          if (injectedTarget.startsWith("grpcht:")) injectRoomType = "group-chat";
          else if (injectedTarget.startsWith("conf:")) injectRoomType = "conference";

          const controlText = JSON.stringify(parsedMessage);
          // Use parsedMessage.id as messageId when available
          const controlMsgId = parsedMessage.id || generateRandomString();

          // receive the message exactly like regular incoming messages.
          if (this.endpoint && typeof this.endpoint.emit === "function") {
            this.endpoint.emit("onMsg", controlText, controlMsgId, injectedFrom, injectedTarget, injectRoomType);
          } else {
            this.handleReceiveMessage(controlText, controlMsgId, injectedFrom, injectedTarget, false, injectRoomType);
          }
          // Always acknowledge scheduled control requests with a 200 OK response
          try {
            this.sendMsg(createResponseControlMessage(parsedMessage.id, "request", "media-comm-sched", 200, "OK", ""), "application/rechat.cntl+json");
          } catch (e) {
            console.warn('Failed to send media-comm-sched ACK response', e);
          }
        } catch (e) {
          console.warn("Failed to inject scheduled control into room messages:", e);
        }
        break;
      case RequestJobs.REQJOB_SESSION_CLOSE:
        this.handleSessionActivation(messageParams.fromName, false);
        break;
      case RequestJobs.REQJOB_SESSION_TRANSFER:
        {
          const fromName = messageParams.fromName || "";
          const targetName = messageParams.targetName || "";
          const transfereeName = messageParams.transfereeName || "";
          const reason = messageParams.reason || "";
          const senderLabel = fromName.split("@")[0] || fromName;
          const transfereeLabel = transfereeName.split("@")[0] || transfereeName;
          const notificationBody = i18n.t("notifications.sessionTransferRequest", {
            ns: "chat",
            defaultValue: `Agent ${senderLabel} transferred the session for ${transfereeLabel} to you.${reason ? ` Reason: ${reason}.` : ""}`,
            sender: senderLabel,
            transferee: transfereeLabel,
            reasonSuffix: reason ? ` Reason: ${reason}.` : "",
          });

          this.addNotification(new MyNotifications(
            parsedMessage.id,
            fromName,
            targetName,
            "session-transfer",
            false,
            {
              title: i18n.t("notifications.sessionTransferRequestTitle", {
                ns: "chat",
                defaultValue: "Session transfer request",
              }),
              body: notificationBody,
              fromName,
              targetName,
              transfereeName,
              reason,
              historyAdded: messageParams.historyAdded,
            },
            new Date()
          ));

          toast.info(notificationBody);
        }
        break;
      case RequestJobs.REQJOB_CLIENT_CONNECTED:
        const id= obtainSessionKey(messageParams.clientName, Global.username+Global.companyDomain);

        this.addRoomCallback(id,[], id, "active", "c2a");
        this.endpoint.emit("ClientConnected", { clientName: messageParams.clientName, sessionKey: id });
        break;
      case RequestJobs.REQJOB_CLIENT_DISCONNECTED:
        this.handleSessionActivation(messageParams.clientName, false);
        break;
      case RequestJobs.REQJOB_CANCEL_ONGOING:
        if (messageParams.responseRequired == "YES") {
          this.sendMsg(createResponseControlMessage(parsedMessage.id, "request", "cancel-ongoing", 200, "OK", ""), "application/rechat.cntl+json");
        }
        this.handleremoveRequest(parsedMessage.id);
        break;
      case RequestJobs.REQJOB_INVITE_MEMBER:
        const im_req = new MyRequest(parsedMessage.id, messageParams.fromName, messageParams.chatroomId, "invite-member", "pending", messageParams.chatType, true, new Date().toISOString(), "");
        this.handleaddRequest(im_req);
        break;
      case RequestJobs.REQJOB_ADDED_PARTICIPANT:
        const participants=[messageParams.fromName,messageParams.toName];
        console.log("chatroomId:" , messageParams.chatroomId,"type :" , messageParams.chatType);
        this.addRoomCallback(messageParams.chatroomId,participants, messageParams.chatroomId, "active", messageParams.chatType);
        break;
      case RequestJobs.REQJOB_LEAVE_CHAT:
        console.log("pass data to ui ");
        break;
      case RequestJobs.REQJOB_DELETE_MESSAGE:
        console.log("message with id : " + messageParams.deletedMessageId + " is deleted");
        this.handleupdateMessage(messageParams.deletedMessageId, "This message has been deleted");
        break;
      case RequestJobs.REQJOB_FILE_TRANSFER:
        console.log("file transfer request received with id : " + messageParams.id);
        const params = {
          direction: "recv",
          "from-name": messageParams.fromName,
          "target-name": messageParams.targetName,
          "file-name": messageParams.fname,
          "file-type": messageParams.ftype,
          "file-title": messageParams.ftitle,
          "file-location": messageParams.flocation,
          "file-size": messageParams.fsize,
          "file-hash": messageParams.fhash,
          "file-disposition": messageParams.fdispos,
          "file-transfer-id": messageParams.fxferId,
        };
        console.log("file name: "+ messageParams.fname + " file type: "+ messageParams.ftype + " file title: "+ messageParams.ftitle + " file location: "+ messageParams.flocation + " file size: "+ messageParams.fsize + " file hash: "+ messageParams.fhash + " file disposition: "+ messageParams.fdispos + " file transfer id: "+ messageParams.fxferId);
        this.sendMsg(createResponseControlMessageReadyParams(parsedMessage.id, "request", parsedMessage.job.str, 200, "OK", params), "application/rechat.cntl+json");
       
        let sentTime = null;
        let deliveredTime = new Date();
        let seenTimes = null;
        let editTime = null;
        let deleteTime = null;
        const stableMessageId = parsedMessage.headerMsgId || parsedMessage.id;

        const fileMessage = new FileMessage(
          messageParams.ftitle,
          messageParams.fname,               
          messageParams.flocation, 
          messageParams.ftype,               
          stableMessageId,     
          false,                 
          messageParams.targetName,       
          messageParams.fromName, 
          null,
          sentTime,
          deliveredTime,
          seenTimes,
          editTime,
          deleteTime,
        );
        
        this.handlereceiveFileMessage(fileMessage);
        break;
    }
  }

  passResponseDataToUp(parsedMessage) {
    console.log("Wrapper :: Parsed Message ID:", parsedMessage.id);
    console.log("Wrapper :: Parsed Message Type:", parsedMessage.type);
    console.log("Wrapper :: Parsed Message Job:", parsedMessage.job);
    console.log("Wrapper :: Parsed Message Data:", JSON.stringify(parsedMessage.cm, null, 2));

    const messageParams = parsedMessage.cm;

    switch (parsedMessage.job) {
      case RequestJobs.REQJOB_AGENT_TO_AGENT:
        console.log("response to agent to agent arrived with id : " + messageParams.id);
        console.log("response to agent to agent arrived with result code : " + messageParams.result_code);
        const mrequest = this.handlefindServerRequest(messageParams.id);

        if (messageParams.result_code == 205) {
          console.log("request is accepted");
          if (mrequest) {
            let id = "a2a:" + obtainSessionKey(mrequest.sender, mrequest.receiver);
            this.addRoomCallback(id, [], id, "active", "agent-to-agent");
          } else {
            console.log("Request with ID " + messageParams.id + " not found.");
          }
          toast.success("You can now chat with " + mrequest.receiver.split("@")[0]);
        } else if (messageParams.result_code == 206 ) {
          toast.warning("session already exist for " + mrequest.receiver.split("@")[0]);
        }else if(messageParams.result_code == 200 && messageParams.result_text=="OK"){
          console.log("a2a real time request is accepted");
          if (mrequest) {
            let id = "a2a:" + obtainSessionKey(mrequest.sender, mrequest.receiver);
            this.addRoomCallback(id, [], id, "active", "agent-to-agent");
          } else {
            console.log("Request with ID " + messageParams.id + " not found.");
          }
          toast.success( mrequest.receiver.split("@")[0]+"accepted your agent to agent request");
        }
        else {
          this.handleupdateReqStatusById(messageParams.id, messageParams.result_text);
          console.log("request is not accepted for reason: " + messageParams.result_text);
          toast.error("Connection to " + mrequest.receiver.split("@")[0] + " failed");
        }
        break;

      case RequestJobs.REQJOB_AGENT_LIST:
        console.log("calling ui to build agent list");
        const agentNames = messageParams.parms.agentList;
        const agentStatuses = messageParams.parms.statusList;
        triggerHandleAgentListResponse(agentNames, agentStatuses);
        break;
      case RequestJobs.REQJOB_CANCEL_ONGOING:
        if (messageParams.result_code == 200) {
          this.handleremoveRequest(parsedMessage.id);
          toast.success("Ongoing request cancelled successfully");
        }
        break;
      case RequestJobs.REQJOB_LEAVE_CHAT:
        console.log("leave chat response received for this id:" + parsedMessage.id);
        if (messageParams.result_code === 200 && messageParams.result_text === "Leave Successful") {
          const request = this.handlefindServerRequest(parsedMessage.id);
          if (request) {
            console.log("request found for leave chat with id: " + parsedMessage.id);
            console.log("request receiver: " + request.receiver);
            this.handleLeaveFromChat(request.receiver);
            toast.success("You have left " + request.receiver.split(":")[1] + " successfully");
          } else {
            toast.success("You have left the chat successfully");
          }
        }else{
          // Emit leaveFailed so UI rollbacks  
          this.endpoint.emit("LeaveChatFailed", { sessionKey: request.receiver, requestId: parsedMessage.id });
          toast.error("Leave chat failed: " + messageParams.result_text);
        }
        break;
      case RequestJobs.REQJOB_SESSION_TRANSFER:
        {
          const request = this.handlefindServerRequest(parsedMessage.id);
          const fromName = request?.sender || request?.detail?.fromName || messageParams.fromName || "";
          const targetName = request?.receiver || request?.detail?.targetName || messageParams.targetName || "";
          const transfereeName = request?.detail?.transfereeName || messageParams.transfereeName || "";
          const resultText = messageParams.result_text || "";
          const isSuccess = messageParams.result_code === 200;
          const notificationBody = isSuccess
            ? i18n.t("notifications.sessionTransferSuccess", {
                ns: "chat",
                defaultValue: "Session transfer successful",
              })
            : i18n.t("notifications.sessionTransferFailure", {
                ns: "chat",
                defaultValue: resultText ? `Session transfer failed: ${resultText}` : "Session transfer failed",
                resultSuffix: resultText ? `: ${resultText}` : "",
              });

          if (isSuccess) {
            toast.success(notificationBody);
          } else {
            toast.error(notificationBody);
          }
        }
        break;
      case RequestJobs.REQJOB_INVITE_MEMBER:
        if (messageParams.result_code === 200 && messageParams.result_text === "OK") {
          const request = this.handlefindServerRequest(parsedMessage.id);
          if (request) {
            handleaddRequest(request);
          }
          toast.success("Member invited successfully");
        }else{
          toast.error("Invite member failed: " + messageParams.result_text);
        }
        break;
      case RequestJobs.REQJOB_JOIN_CHAT:
        const request = this.handlefindRequest(parsedMessage.id);
        if (messageParams.result_code === 200) {
          console.log("join chat accepted");
          this.handleupdateReqStatusById(messageParams.id, "approved");
          this.addRoomCallback(request.detail, [],request.detail, "active", "conference");
          toast.success("You have joined the chat successfully");
        }else{
          toast.error("Join chat rejected: " + messageParams.result_text);
        }
        break;
        case RequestJobs.REQJOB_CHAT_LIST:
          console.log("calling ui to build chat list");
          console.log("this is chatlist:", messageParams.parms.chatList);
          console.log("participant list in wrapper:", messageParams.parms.participantList);
          
          const chatroomIds = [];
          const chatTypes = [];
          const extractedNames = [];
          const statuses = [];
          const participantLists = [];
          const chatList = messageParams.parms.chatList;
        
          if (!chatList || !Array.isArray(chatList)) {
              console.error("Invalid chatList provided");
              this.setAvailableRooms([]);
              break;
          }
          
          chatList.forEach((chatItem) => {
              const { sessionkey, sessionStatus, chatType, participants } = chatItem;
              
              console.log(`Processing session: ${sessionkey} with status: ${sessionStatus}`);
              
              if (!sessionkey) {
                  console.warn("Skipping chat item with missing sessionkey");
                  return;
              }
              
              chatroomIds.push(sessionkey);
              statuses.push(sessionStatus);
              participantLists.push(participants || []);
               
              if (chatType==="grpcht") {
                  chatTypes.push("group-chat");
              } else if (chatType==="conf") {
                  chatTypes.push("conference");
              } else if (chatType==="c2a") {
                  chatTypes.push("c2a");
              } else if (chatType==="a2a-rt") {
                  chatTypes.push("agent-to-agent");
              } else if (chatType==="a2a-st") {
                  chatTypes.push("agent-to-agent");
              } else if (chatType==="ft") {
                  chatTypes.push("file-transfer");
              }else{chatTypes.push("undefined");}
             
                  extractedNames.push(sessionkey);
              
          });
      
          console.log("this is extractednames:", extractedNames);
          console.log("this is chatTypes:", chatTypes);
          console.log("this is statuses:", statuses);
      
          if (chatTypes.length > 0) {
              if(messageParams.parms.personal){
                    this.clearAllChatRooms();
              }
              
              chatroomIds.forEach((id, index) => {
                  
                  if (messageParams.parms.personal) {
                      this.addRoomCallback(
                          extractedNames[index], 
                          participantLists[index], 
                          chatroomIds[index], 
                          statuses[index], 
                          chatTypes[index]
                      );
                  }
              });
              
              this.handleChatListResponse(extractedNames, chatTypes, statuses);
          } else {
              this.setAvailableRooms([]);
          }
          
          break;
      case RequestJobs.REQJOB_START_CONFERENCE:
        if (messageParams.result_code === 301 && messageParams.result_text === "Conference name modified") {
          console.log("Conference name modified received");
          const request = this.handlefindServerRequest(parsedMessage.id);
          if (request) {
            this.addRoomCallback(request.detail,request.receiver,request.detail,"active", "conference");
          }
        }else
        {toast.error("Conference creation failed: " + messageParams.result_text);}
        break;
      case RequestJobs.REQJOB_CREATE_GROUPCHAT:
        if (messageParams.result_code === 301 && messageParams.result_text === "Groupchat name modified") {
          console.log("group name modified received");
          const request = this.handlefindServerRequest(parsedMessage.id);
          if (request) {
            this.addRoomCallback(request.messageID,request.detail, request.messageID,"active", "group-chat");
          }
          toast.success("Groupchat created successfully");
        } else {
          console.log("groupchat creation failed: " + messageParams.result_text);
          toast.error("Groupchat creation failed: " + messageParams.result_text);
        }
        break;
      case RequestJobs.REQJOB_EDIT_MESSAGE:
        console.log("edit message response received for this id:" + parsedMessage.id);
        console.log("edit message result code:" + messageParams.result_code);
        console.log("edit message result text:" + messageParams.result_text);
        if (messageParams.result_code === 200 && messageParams.result_text === "OK") {
          const request = this.handlefindServerRequest(parsedMessage.id);
          if (!request) {
            console.error("Request not found:", requestId);
            return;
          }
          console.log("update text: " + request.detail + " message id: " + request.messageID);
          this.handleupdateMessage(request.messageID, request.detail);
          this.handleremoveServerRequest(parsedMessage.id);
          toast.success("Message edited successfully");
        }else{
          toast.error("Edit message failed: " + messageParams.result_text);
        }
        break;
      case RequestJobs.REQJOB_DELETE_MESSAGE:
        console.log("delete message response received for this id:" + parsedMessage.id);
        if (messageParams.result_code === 200 && messageParams.result_text === "OK") {
          const delrequest = this.handlefindServerRequest(parsedMessage.id);
          this.handleupdateMessage(delrequest.messageID, "This message has been deleted");
          toast.success("Message deleted successfully");
        } else {
          console.log("delete message failed: " + messageParams.result_text);
          toast.error("Delete message failed: " + messageParams.result_text);
        }
        break;

        case RequestJobs.REQJOB_REPLY_TO:
        console.log("reply message response received for this id:" + parsedMessage.id);
        console.log("reply message result code:" + messageParams.result_code);
        console.log("reply message result text:" + messageParams.result_text);
        if (messageParams.result_code === 200 && messageParams.result_text === "OK") {
          const request = this.handlefindServerRequest(parsedMessage.id);
          if (!request) {
            console.error("Request not found:", request.id);
            return;
          }
          console.log("reply text: " + request.detail + " message id: " + request.messageID);
          console.log("headerMsgId in request " + request.headerMsgId);
          this.handleReceiveMessage(request.detail,request.headerMsgId,request.sender,request.receiver,true,request.status,request.messageID);
          this.handleremoveServerRequest(parsedMessage.id);
          toast.success("Reply message sent successfully");
        }
        else{
          toast.error("Reply message failed: " + messageParams.result_text);
        }
        break;
      case RequestJobs.REQJOB_DELETE_CHAT:
        if (messageParams.result_code === 200 && messageParams.result_text === "OK") {
          console.log("chat destroyed deleted successfully");
          const request = this.handlefindServerRequest(parsedMessage.id);
          if (request) {
            this.handleSessionActivation(request.receiver, false);
          }
        } else {
          console.log("destroy chat failed: " + messageParams.result_text);
          toast.error("Destroy chat failed: " + messageParams.result_text);
        }
        break;
      case RequestJobs.REQJOB_FILE_TRANSFER:
        console.log("file transfer response received with id : " + messageParams.id);
        // const req = this.handlefindRequest(messageParams.id);
        // const file = req.detail;
        // const fileSize = file.size;
        // const fileName = file.name;
        // const creationDate = file.lastModified;
        // const modificationDate = file.lastModified;
        // const readDate = file.lastModified;

        // const contentDisposition = `attachment;filename="${fileName}";creation-date="${creationDate}";modification-date="${modificationDate}";read-date="${readDate}";size=${fileSize}`;
        // this.sendFile(file, messageParams.parms.fxferId, contentDisposition);
        if(messageParams.result_code === 200 && messageParams.result_text === "OK"){
          toast.success("File sent successfully");
        }else{        toast.error(messageParams.result_text);
        }
        break;
    }
  }

  passNotifyDataToUp(parsedMessage) {
    console.log("Wrapper :: Parsed Message ID:", parsedMessage.id);
    console.log("Wrapper :: Parsed Message Type:", parsedMessage.type);
    console.log("Wrapper :: Parsed Message Event:", parsedMessage.event);
    console.log("Wrapper :: Parsed Message Data:", JSON.stringify(parsedMessage.cm, null, 2));

    switch (parsedMessage.event) {
      case SubscriptionEvents.SUBSEVENR_MESSAGE_SENT.enum:
        //later we can let the user know about it
        break;
      case SubscriptionEvents.SUBSEVENR_USER_JOINED.enum:
        const notifier = parsedMessage.cm.notifier;
        console.log(notifier);
        const confName = notifier.split(":");
        let notificationNotif = {
          id: parsedMessage.id,
          sender: parsedMessage.cm.source,
          receiver: Global.username,
          event: "user-joined",
          isSeen: false,
          detail: `agent ${parsedMessage.cm.source.split("@")[0]} joined to ${confName[1]}`,
          timestamp: new Date(),
        };
        this.addNotification(notificationNotif);
        this.addRoomCallback(notifier, [], notifier, "active", "conference");
        this.handleAddParticipant(notifier,parsedMessage.cm.source);
        break;
      case SubscriptionEvents.SUBSEVENT_TIMEOUT.enum:
        {
          const sourceName = parsedMessage.cm?.source || "unknown user";
          const notifierName = parsedMessage.cm?.notifier || "unknown conference";
          if (!notifierName.startsWith("conf:")) {
            // if it's not a conference invite timeout, ignore 
            break;
          }
          const readableSource = sourceName.split("@")[0];
          const readableNotifier = notifierName.replace(/^conf:/i, "");

          toast.error(
            `Inviting ${readableSource} to conference ${readableNotifier} timed out. Agent didn't answer.`,
          );
        }
        break;
      case SubscriptionEvents.SUBSEVENT_USER_LEFT.enum:
        console.log(parsedMessage.cm.source + " left the chat");
        const chatroom = parsedMessage.cm.notifier.trim().split(":");
        toast.info(parsedMessage.cm.source.split("@")[0] + " left from " + chatroom[1] + " chatroom");
        this.handleRemoveParticipant(parsedMessage.cm.notifier,parsedMessage.cm.source);
        break;
      case SubscriptionEvents.SUBSEVENT_MESSAGE_SEEN.enum:
        console.log("message seen"+ parsedMessage.cm.source + " at " + parsedMessage.cm.notifier);
        this.updateMessageStatus(parsedMessage.cm.source, "seenTimes", new Date(parsedMessage.cm.parms.seenTime * 1000),parsedMessage.cm.notifier);
        break;
      case SubscriptionEvents.SUBSEVENT_AGENT_AVAILABLE.enum:
        console.log("agent" + parsedMessage.cm.source + "is available");
        let newNotif = {
          id: parsedMessage.id,
          sender: parsedMessage.cm.source,
          receiver: Global.username,
          event: "agent-available",
          isSeen: false,
          detail: `${parsedMessage.cm.source.split("@")[0]} is available now`,
          timestamp: new Date(),
        };
        this.addNotification(newNotif);
        break;
      case SubscriptionEvents.SUBSEVENT_AGENT_BREAK.enum:
        console.log("agent" + parsedMessage.cm.source + "is in break");
        let Notif = {
          id: parsedMessage.id,
          sender: parsedMessage.cm.source,
          receiver: Global.username,
          event: "agent-break",
          isSeen: false,
          detail: `${parsedMessage.cm.source.split("@")[0]} is on break now`,
          timestamp: new Date(),
        };
        this.addNotification(Notif);
        break;
      case SubscriptionEvents.SUBSEVENT_AGENT_EMPTY.enum:
        console.log("agent" + parsedMessage.cm.source + "is empty");
        let nNotif = {
          id: parsedMessage.id,
          sender: parsedMessage.cm.source,
          receiver: Global.username,
          event: "agent-empty",
          isSeen: false,
          detail: `${parsedMessage.cm.source} is empty now`,
          timestamp: new Date(),
        };
        this.addNotification(nNotif);
        break;
      case SubscriptionEvents.SUBSEVENT_AGENT_FULL.enum:
        console.log("agent" + parsedMessage.cm.source + "is full");
        let NewNotif = {
          id: parsedMessage.id,
          sender: parsedMessage.cm.source,
          receiver: Global.username,
          event: "agent-full",
          isSeen: false,
          detail: `${parsedMessage.cm.source} is full now`,
          timestamp: new Date(),
        };
        this.addNotification(NewNotif);
        break;
      case SubscriptionEvents.SUBSEVENT_AGENT_HELP_REQ.enum:
        console.log("agent" + parsedMessage.cm.source + "request for help");
        let Notification = {
          id: parsedMessage.id,
          sender: parsedMessage.cm.source,
          receiver: Global.username,
          event: "agent-help-req",
          isSeen: false,
          detail: `${parsedMessage.cm.source.split("@")[0]} needs help now`,
          timestamp: new Date(),
        };
        this.addNotification(Notification);
        break;
      case SubscriptionEvents.SUBSEVENT_AGENT_LOGIN.enum:
        console.log("agent" + parsedMessage.cm.source + "is logged in");
        let newNotifi = {
          id: parsedMessage.id,
          sender: parsedMessage.cm.source,
          receiver: Global.username,
          event: "agent-login",
          isSeen: false,
          detail: `${parsedMessage.cm.source} is logged in now`,
          timestamp: new Date(),
        };
        this.addNotification(newNotifi);
        break;
      case SubscriptionEvents.SUBSEVENT_AGENT_LOGOUT.enum:
        console.log("agent" + parsedMessage.cm.source + "is loggedd out");
        let newNotification = {
          id: parsedMessage.id,
          sender: parsedMessage.cm.source,
          receiver: Global.username,
          event: "agent-logout",
          isSeen: false,
          detail: `${parsedMessage.cm.source} is logged out now`,
          timestamp: new Date(),
        };
        this.addNotification(newNotification);
        break;
      case SubscriptionEvents.SUBSEVENT_AGENT_SUSPEND.enum:
        console.log("agent" + parsedMessage.cm.source + "is suspended");
        let Notifii = {
          id: parsedMessage.id,
          sender: parsedMessage.cm.source,
          receiver: Global.username,
          event: "agent-suspend",
          isSeen: false,
          detail: `${parsedMessage.cm.source} is suspend now`,
          timestamp: new Date(),
        };
        this.addNotification(Notifii);
        break;
      case SubscriptionEvents.SUBSEVENR_CONFERENCE_CREATED.enum:
        break;
      case SubscriptionEvents.SUBSEVENR_CONFERENCE_DESTROYED.enum:
        console.log("the conference is destroyed");
        const conferenceName = parsedMessage.cm.notifier;
        const extractedName = conferenceName.replace("conf:", "");
        console.log(extractedName);
        toast.error(`The "${extractedName}" conference has been destroyed. You can no longer send messages.`);
        this.handleSessionActivation(conferenceName, false);
        this.endpoint.emit("SessionDestroyed", { sessionKey: conferenceName });
        break;
      case SubscriptionEvents.SUBSEVENR_GROUPCHAT_DESTROYED.enum:
        console.log("the GROUP CHAT is destroyed");
        const grName = parsedMessage.cm.notifier;
        const Name = grName.replace("grpcht:", "");
        console.log(Name);
        toast.error(`The "${Name}" group has been destroyed. You can no longer send messages.`);
        this.handleSessionActivation(grName, false);
        this.endpoint.emit("SessionDestroyed", { sessionKey: grName });
        break;
      case SubscriptionEvents.SUBSEVENR_sess_create_promotion.enum:
        console.log("you are the admin");
        const name = parsedMessage.cm.notifier.trim().split(":");
        const confname = name[1];
        this.setIsCreator(confname, true);
        this.endpoint.emit("AdminPromoted", { sessionKey: parsedMessage.cm.notifier });
        break;
      case SubscriptionEvents.SUBSEVENT_UNKNOWN:
        console.log("unknown event ");
        break;
    }
  }
}

export default Wrapper;